import { assessmentQuestionTypes } from '../../reducers/types';
import { assessmentQuestionService } from '../../service/question/assessmentQuestionService';

export const assessmentQuestionActions = {
    createMCQQuestion,
    createQuestion,
    createSubQuestion,
    createMainQuestion,
    saveAnswer
};

function createMCQQuestion(obj) {
    
    return async dispatch => {

        dispatch(clearExisting());
        dispatch(request());

        try {
            let data = await assessmentQuestionService.saveMCQQuestion(obj);
            if(data.success){
                dispatch(success(data.data))
            }
            else{
                dispatch(failure(data.message))
            }
        } catch (error) {
            dispatch(failure(error));
        }
    };

    function clearExisting() {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_MCQ_QUESTION}
    }

    function request() {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_MCQ_QUESTION_REQUEST}
    }

    function success(question) {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_MCQ_QUESTION_SUCCESS, question}
    }

    function failure(error) {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_MCQ_QUESTION_FAILURE, error}
    }
}

function createQuestion(obj) {
    return async dispatch => {
        
        dispatch(clearExisting());
        dispatch(request());

        await assessmentQuestionService.saveQuestion(obj)
            .then(
                data => {
                    if(data.success){
                        dispatch(success(data.data))
                    }
                    else{
                        dispatch(failure(data.message))
                    }
                },
                error => {
                    dispatch(failure(error.toString()))
                }
            );
    };

    function clearExisting() {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION}
    }

    function request() {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION_REQUEST}
    }

    function success(question) {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION_SUCCESS, question}
    }

    function failure(error) {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION_FAILURE, error}
    }
}

function createSubQuestion(obj) {
    return async dispatch => {
        
        dispatch(clearExisting());
        dispatch(request());

        await assessmentQuestionService.saveSubQuestion(obj)
            .then(
                data => {
                    if(data.success){
                        dispatch(success(data.data))
                    }
                    else{
                        dispatch(failure(data.message))
                    }
                },
                error => {
                    dispatch(failure(error.toString()))
                }
            );
    };

    function clearExisting() {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION}
    }

    function request() {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION_REQUEST}
    }

    function success(question) {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION_SUCCESS, question}
    }

    function failure(error) {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION_FAILURE, error}
    }
}

function createMainQuestion(obj) {
    return async dispatch => {
        
        dispatch(clearExisting());
        dispatch(request());

        await assessmentQuestionService.saveMainQuestion(obj)
            .then(
                data => {
                    if(data.success){
                        dispatch(success(data.data))
                    }
                    else{
                        dispatch(failure(data.message))
                    }
                },
                error => {
                    dispatch(failure(error.toString()))
                }
            );
    };

    function clearExisting() {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION}
    }

    function request() {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION_REQUEST}
    }

    function success(question) {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION_SUCCESS, question}
    }

    function failure(error) {
        return {type: assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION_FAILURE, error}
    }
}


function saveAnswer(obj) {
    return async dispatch => {
        
        dispatch(request());

        await assessmentQuestionService.saveAnswer(obj)
            .then(
                question => {
                    if(question.success){
                        dispatch(success(question.data))
                    }
                    else{
                        dispatch(failure(question.message))
                    }
                },
                error => {
                    dispatch(failure(error.toString()))
                }
            );
    };

    function request() {
        return {type: assessmentQuestionTypes.ADD_ASSESSMENT_QUESTION_ANSWER_REQUEST}
    }

    function success(question) {
        return {type: assessmentQuestionTypes.ADD_ASSESSMENT_QUESTION_ANSWER_SUCCESS, question}
    }

    function failure(error) {
        return {type: assessmentQuestionTypes.ADD_ASSESSMENT_QUESTION_ANSWER_FAILURE, error}
    }
}
